import { render, staticRenderFns } from "./hotel-beds-preview.vue?vue&type=template&id=61f3b16a"
import script from "./hotel-beds-preview.vue?vue&type=script&lang=js"
export * from "./hotel-beds-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports